// ========================================================
// SUPERSCRIPTS
// Replace symbols with superscripted versions.
//
// Walks text nodes and only rewrites the ones that actually contain a
// symbol. Rewriting innerHTML on every p/h/li/a instead re-parses the
// whole page several times over and drops any listeners bound to
// their children.
// ========================================================
(() => {
	const SYMBOLS = /[†‡®™🅫🅪]/;
	const SYMBOL_MAP = {
		"†": "&dagger;",
		"‡": "&Dagger;",
		"®": "&reg;",
		"™": "&trade;",
		"🅫": "&trade;",
		"🅪": "&trade;",
	};
	const HOSTS = new Set(["P", "H1", "H2", "H3", "H4", "LI", "A"]);
	// Never rewrite inside these — it would corrupt code/scripts or
	// re-wrap a symbol we already superscripted.
	const SKIP = new Set(["SCRIPT", "STYLE", "TEXTAREA", "CODE", "PRE", "SUP"]);

	const walker = document.createTreeWalker(
		document.body,
		NodeFilter.SHOW_TEXT,
		{
			acceptNode(node) {
				if (!SYMBOLS.test(node.nodeValue)) {
					return NodeFilter.FILTER_REJECT;
				}
				for (let el = node.parentElement; el; el = el.parentElement) {
					if (SKIP.has(el.tagName)) return NodeFilter.FILTER_REJECT;
					if (HOSTS.has(el.tagName)) return NodeFilter.FILTER_ACCEPT;
					if (el === document.body) break;
				}
				return NodeFilter.FILTER_REJECT;
			},
		}
	);

	// Collect first — replacing nodes while walking invalidates the walker.
	const targets = [];
	let current;
	while ((current = walker.nextNode())) {
		targets.push(current);
	}

	const escapeHtml = (text) =>
		text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

	for (const node of targets) {
		const replacement = document.createElement("span");
		replacement.innerHTML = escapeHtml(node.nodeValue).replace(
			/[†‡®™🅫🅪]/g,
			(symbol) => `<sup>${SYMBOL_MAP[symbol]}</sup>`
		);
		node.replaceWith(...replacement.childNodes);
	}
})();
